import { MAT_EXPANSION_PANEL_DEFAULT_OPTIONS } from '@angular/material/expansion';
import { MatInputModule, MatInput } from '@angular/material/input';
import { MatPaginatorIntl } from '@angular/material/paginator';

const dutchRangeLabel = (page: number, pageSize: number, length: number) => {
  if (length == 0 || pageSize == 0) { return `0 מתוך ${length}`; }
  
  length = Math.max(length, 0);

  const startIndex = page * pageSize;

  // If the start index exceeds the list length, do not try and fix the end index to the end.
  const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex} מתוך ${length}`;
}


export function getDutchPaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();
  paginatorIntl.itemsPerPageLabel = '';
  paginatorIntl.firstPageLabel = 'עמוד ראשון';
  paginatorIntl.nextPageLabel= 'עמוד הבא';
  paginatorIntl.previousPageLabel = 'עמוד קודם';
  paginatorIntl.lastPageLabel = 'עמוד אחרון';  
  paginatorIntl.getRangeLabel = dutchRangeLabel;
  
  return paginatorIntl;
}